import React from 'react';


class Feature extends React.Component {
   render() {

      return (
         <section id="feature" className="feature">
            <div className="feature-decor">
               <div className="feature-circle1"><img src="assets/images/feature2.png" alt="" /></div>
            </div>
            <div className="container">
               <div className="row">
                  <div className="feature-phone">
                     <img src="assets/images/222.png" className="img-fluid" alt="" />
                  </div>
                  <div className="offset-lg-4 col-lg-8">
                     <div className="row">
                        <div className="col-sm-12 mrgn-md-top">
                           <h2 className="title"><span>ΠΩΣ ΛΕΙΤΟΥΡΓΕΙ</span></h2>
                        </div>
                        <div className="col-12 col-md-6">
                           <ul className="feature-style">
                              <li>
                                 <div className="feature-icon">
                                    <img src="assets/images/icon/1.png" alt="icon" />
                                 </div>
                                 <div className="feature-subtitle">
                                    <h3>Σάρωση QR CODE</h3>
                                 </div>
                                 <div>
                                    <p>Κατεβάζετε την εφαρμογή και σκανάρετε με την κάμερα του κινητού σας τον κωδικό QR που υπάρχει στα περίπτερα των εκθετών. </p>
                                 </div>
                              </li>
                              <li>
                                 <div className="feature-icon">
                                    <img src="assets/images/icon/3.png" alt="icon" />
                                 </div>
                                 <div className="feature-subtitle">
                                    <h3>Πληροφορίες για τους εκθέτες</h3>
                                 </div>
                                 <div>
                                    <p>Κάθε εκθέτης έχει οργανωμένες πληροφορίες (περιγραφή, στοιχεία επικοινωνίας, φωτογραφίες,). Εσείς επιλέγετε ποιοι εκθέτες θα αποθηκευτούν στην εφαρμογή. </p>
                                 </div>
                              </li>

                           </ul>
                        </div>
                        <div className="col-12 col-md-6 sm-m-top">
                           <ul className="feature-style">
                              <li>
                                 <div className="feature-icon">
                                    <img src="assets/images/icon/2.png" alt="icon" />
                                 </div>
                                 <div className="feature-subtitle">
                                    <h3>Επικοινωνία με τους εκθέτες</h3>
                                 </div>
                                 <div>
                                    <p>Ανα πάσα στιγμή, ακόμα και μετά την έκθεση, μπορείτε να δείτε όλα τα στοιχεία των εκθετών και να επικοινωνήσετε μαζί τους.</p>
                                 </div>
                              </li>
                              <li>
                                 <div className="feature-icon">
                                    <img src="assets/images/icon/4.png" alt="icon" />
                                 </div>
                                 <div className="feature-subtitle">
                                    <h3>Request επικοινωνίας</h3>
                                 </div>
                                 <div>
                                    <p>Με το πάτημα ενός κουμπιού, έχετε την δυνατότητα να ζητήσετε από τον εκθέτη να επικοινωνήσει μαζί σας, όποτε επιθυμείτε. </p>
                                 </div>
                              </li>

                           </ul>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      );
   }
}


export default Feature;


// WEBPACK FOOTER //
// ./src/components/feature.js